import { useMemo } from "react";
import { useSelector } from "react-redux";

import { getDesignerNodeByIdSelector } from "../../state";
import { NodeTreeEntry } from "./NodeTreeEntry";

interface Props {
  contextNodeId: number;
}

export const InteractiveNodeTree = ({ contextNodeId }: Props) => {
  const getById = useSelector(getDesignerNodeByIdSelector);

  const contextNode = useMemo(() => getById(contextNodeId), [contextNodeId, getById]);

  return <NodeTreeEntry node={contextNode} excludeSelf />;
};
